module.exports = __webpack_public_path__ + "410edcc4dec82cbe82fb02faa09e478a.pdf";